<template>
  <div>
    <v-layout>
      <v-text-field label="Araç Seçimi"  :placeholder="kodmesajı" append-icon="search"
        @click:append="dialogac()" :tabindex="tabdeger" v-model="val.kalemRentACar.arac" hide-details=""></v-text-field>
      
    </v-layout>
    <v-dialog scrollable="" v-model="dialog" max-width="600px">
      <v-card color="grey lighten-4">
        <v-toolbar size="120px" color="info">
          <v-toolbar-title class="white--text">Araç Listesi</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field solo hide-details ref="ara" autofocus="" v-model="aranandeger" label="Kayıtlarda Ara"
            append-icon="search"></v-text-field>
        </v-toolbar>
        <v-card-text>
          <v-layout row="" wrap="">

            <v-flex>
              <v-select hide-details :items="[]" :label="$t('Category')" item-text="aciklama" item-value="kod">
              </v-select>
            </v-flex>
            <div class="flex md12">
              <v-data-table :headers="headersservis" :search="aranandeger" :loading="progress" :items="listitems"
                hide-actions class="elevation-1">
                <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                <template slot="items" slot-scope="props">
                  <tr @click="kabul(props.item)" item>
                    <td class="text-xs-left">{{ props.item.Kod }}</td>
                    <td class="text-xs-left">{{ props.item.Marka }}</td>
                    <td class="text-xs-left">{{ props.item.Model }}</td>
                    <td class="text-xs-left">{{ props.item.AracAd }}</td>
                    <td class="text-xs-left">{{ props.item.Plaka }}</td>

                    <td class="justify-center layout px-0">
                    </td>
                  </tr>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                   {{ $t('No-records-searched-for', { value: aranandeger}) }}
                </v-alert>
              </v-data-table>

            </div>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialog = false">
            {{$t("cancel_button")}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card>
      <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
        :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
      </v-snackbar>
    </v-card>
  </div>
</template>


<script>
  import auth from '../../../../api/auth'
  import tool from "../tools";

  export default {
    props: ["value", "tabdeger", "getcode","kategori"],
    computed: {
      val: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },


    beforeMount: beforeMount,
    methods: {
      kayitgetir: kayitgetir,
      dialogac: dialogac,
      kabul: kabul,
      codeControl: codeControl,
      Ara
    },
    data() {
      return {
        kategoritems: [],
        plaka:'',
        headersservis: [{
            text: this.$t('Code'),
            value: 'Kod'
          },
          {
            text: this.$t('Brand'),
            value: 'Marka',
          },
          {
            text: this.$t('Model'),
            value: 'Model',

          },
          {
            text: this.$t('Vehicle-Name'),
            value: 'AracAd',
          },
          {
            text: this.$t('License-Plate'),
            value: 'Plaka',
          }],
        kodmesajı: null,
        progress: false,
        listitems: [],
        aranacakkelime: null,
        aranandeger: null,
        dialog: false,

        text1: null,
        loading: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
      }
    },

    watch: {
      //  secilendeger(val) {
      /// val && this.kayitgetir(val)
      // },

      dialog(val2) {
        if (!val2) return
        requestAnimationFrame(() => {
          this.$refs.ara.focus()
        })
      }

    },
  }

  function codeControl() {

    // if (this.val != null && this.val != '') {

    //   var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    //   var params1 = {
    //     CompanyCode: credentials.SirketKodu,
    //     Code: escape(this.val),
    //   }
    //   this.$http.post(auth.API_URL + 'api/ExpenseCenter/Get', params1, {
    //     headers: {
    //       'Authorization': 'Bearer ' + auth.getAuthHeader()
    //     }
    //   }).then((response) => {

    //     if (response.body.length == 1) {
    //       this.val = response.body[0].Code
    //       this.kodmesajı = null
    //     } else {
    //       this.kodmesajı = 'Hatalı kod girişi..'
    //       this.val = null
    //     }
    //   }, (response) => {
    //     if (response.status === 0) {
    //       this.text1 = 'Service Unavailable-listitems'
    //       this.snackbar = true
    //       this.progress = false
    //     } else {
    //       this.text1 = 'Service Unavailable-listitems'
    //       this.snackbar = true
    //       this.progress = false
    //     }
    //   })
    // } else {
    //   this.kodmesajı = null
    // }
  }



  function kabul(m) {

    this.val.kalemRentACar.arac = m.Kod
    
    console.log(m);
      var prm = {
        id:null,
        kod: m.RentACarKod,
        aciklama:null,// v,
        tip: 5
      };

        this.Ara(prm);
     // this.val.satici.kod=m.RentACarKod

    this.dialog = false
  }


  function Ara(prm) {
      tool.http_post(this, 'SaticiAra', prm).then(
        response => {

          var a= {
            kod:null,
            id:null,
            isim:null,
            tip:null
          }
          this.val.satici=a

          this.val.satici.kod=response.body[0].kod
          this.val.satici.id=response.body[0].id
          this.val.satici.isim=response.body[0].isim
          this.val.satici.tip=response.body[0].tip
        },
        response => {
        //  this.status = tool.responseToStatus(response);
        }
      );
    }

  function dialogac() {
    var params = {
      RentACarKod: this.getcode.kod,
      Kategori:null,// this.kategori,
      Kod: null,

    }
    tool.http_post(this, "RentACarAracKodAra", params).then(
      response => {

        if (response.body.Status == true) {

          this.listitems = response.body.data
        } else {

          this.text1 = 'Service Unavailable-RentACarAracKodAra'
          this.snackbar = true
        }
      },
      response => {

        this.text1 = 'Service Unavailable-RentACarAracKodAra'
        this.snackbar = true
      }
    );
    this.dialog = true
  }

  function beforeMount() {
console.log(this.val);
  }

  function kayitgetir(y) {

    if (y != null) {

      if (y.length > 0) {

        this.progress = true

        var params = {
          Kod: null,
          Tip: null,
          Aciklama: null,
          Bolge: null,
          Nerden: null,
          Nereye: null,
          ADT: null,
        }
        tool.http_post(this, "TasimaTipleriAra", params).then(
          response => {

            if (response.body.Status == true) {

              this.aractipitems = response.body.data


            } else {

              this.text1 = 'Service Unavailable-TasimaFiyatKalemTipArama'
              this.snackbar = true
            }
          },
          response => {

            this.text1 = 'Service Unavailable-TasimaFiyatKalemTipArama'
            this.snackbar = true
          }
        );
      } else {
        this.listitems = []
        this.progress = false
      }

    }
  }
</script>